// extracted by mini-css-extract-plugin
export default {"editingPage":"EditingPage_editingPage__MF651"};